/* eslint-disable no-console */
export const LogLevels = {
  NONE: 0,
  ERROR: 1,
  WARN: 2,
  INFO: 3,
  DEBUG: 4,
  TRACE: 5,
};

export class Logger {
  constructor(name) {
    this.name = name || '';
    this.prefix = this.name ? `${name} ` : '';
    if (window.logLevel) {
      this.logLevel = window.logLevel;
    } else {
      this.logLevel = 0;
    }
  }

  // Generic one, skips log level, wrapper for console.log
  log(message) {
    if (this.logLevel >= LogLevels.NONE) {
      console.log(`${this.prefix}${message}`);
    }
  }

  error(message) {
    if (this.logLevel >= LogLevels.ERROR) {
      console.error(`[ERROR] ${this.prefix}${message}`, message);
    }
  }

  warn(message) {
    if (this.logLevel >= LogLevels.WARN) {
      console.warn(`[WARN] ${this.prefix}${message}`);
    }
  }

  info(message) {
    if (this.logLevel >= LogLevels.INFO) {
      console.info(`[INFO] ${this.prefix}${message}`);
    }
  }

  debug(message) {
    if (this.logLevel >= LogLevels.DEBUG) {
      console.info(`[DEBUG] ${this.prefix}${message}`);
    }
  }

  trace(message) {
    if (this.logLevel >= LogLevels.TRACE) {
      console.info(`[TRACE] ${this.prefix}${message}`);
    }
  }
}

export default new Logger();
